module.exports = "/assets/data/300873050c73fbdf489fcda92c298be1-GU17.data.json";